import ClassicGameActivity from './ClassicGameActivity/ClassicGameActivity';
import LegacyGameActivity from './LegacyGameActivity/LegacyGameActivity';
import SortImagesGameActivity from './SortImagesGameActivity/SortImagesGameActivity';

export default function GameActivity({
  activity,
  activityConf,
  taskActivityConf,
  initialTaskProgress,
  taskProgressActions,
  demoMode,
}) {
  let TypeGameActivity = null;
  switch (activity.data.subType) {
    case 'classic':
      TypeGameActivity = ClassicGameActivity;
      break;
    case 'sortImages':
      TypeGameActivity = SortImagesGameActivity;
      break;
    default:
      TypeGameActivity = LegacyGameActivity;
  }

  return (
    <TypeGameActivity
      activity={activity}
      activityConf={activityConf}
      taskActivityConf={taskActivityConf}
      initialTaskProgress={initialTaskProgress}
      taskProgressActions={taskProgressActions}
      demoMode={demoMode}
    />
  );
}
